import React from 'react';
import { withTheme } from 'styled-components';

const RemoveBookFromShelfIcon = ({ width, height, theme }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="11.7727"
        y="1.87866"
        width="5.63636"
        height="15.0303"
        rx="1"
        fill={
          theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon
            .booksIconColor
        }
        fillOpacity="0.9"
      />
      <rect
        x="19.2878"
        width="3.75757"
        height="16.9091"
        rx="0.5"
        fill={
          theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon
            .booksIconColor
        }
        fillOpacity="0.9"
      />
      <rect
        x="23.749"
        y="2.66333"
        width="4.69696"
        height="14.4177"
        rx="0.5"
        transform="rotate(-9.21973 23.749 2.66333)"
        fill={
          theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon
            .booksIconColor
        }
        fillOpacity="0.9"
      />
      <rect
        x="10.8334"
        y="17.8486"
        width="20.6666"
        height="1.87879"
        rx="0.5"
        fill={
          theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon
            .booksIconColor
        }
        fillOpacity="0.9"
      />
      <circle
        cx="8.48484"
        cy="16.4392"
        r="7.98484"
        fill={
          theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon
            .circleBackground
        }
      />
      <path
        d="M5 16.2223C5.91122 17.3071 7.33333 19 7.33333 19C7.33333 19 10 16 12 14"
        stroke={
          theme.themeColors.controlBar.rightPanel.icons.bookshelfIcon.iconColor
        }
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default withTheme(RemoveBookFromShelfIcon);
